const CTXT = '';

export const EVENT = `${CTXT}/api/event`;
//export const EVENT = 'http://scheduler.doas.ga.gov/api/event';